// ABOUTME: Builds the shared TanStack Query client with app-wide query defaults.
// ABOUTME: A default staleTime keeps queries fresh across navigation, avoiding refetch-on-mount storms.
import { QueryClient } from '@tanstack/react-query';

// Queries stay fresh for 30s so navigating between pages (which remounts query
// observers) doesn't trigger a background refetch for data fetched moments ago.
export const DEFAULT_STALE_TIME = 30_000;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: DEFAULT_STALE_TIME,
      },
    },
  });
}

// Only fx-rate queries derive from the user's display currency, so a currency
// change invalidates just those — never the whole cache.
export function invalidateCurrencyDependentQueries(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['fx'] });
}
